import { get, filter } from 'lodash';
import { searchEntities } from '../../store/selectors/search';
import { selectAuthenticatedUser } from '../../store/selectors/auth'

export const selectFaqsNotesDocuments = state => get(state, ['faqsNotesDocuments'], []);

export const selectFaqs = state => searchEntities(state, 'faqs', ['question', 'answer', 'type', 'issue', 'linkTitle', 'caption', 'category', 'image']);

export const selectNotes = (state) => {
    let notes = searchEntities(state, 'notes', ['title', 'body', 'image', 'author.firstName', 'author.lastName'])
    let user = selectAuthenticatedUser(state);
    if(user.roles[0].role.name === 'Home Owner' || (user.roles[0].role.name === 'Realtor' || user.roles[0].role.name === 'Occupant')){
        notes = notes.length > 0 ?notes.filter(x=>x.noteVisibleToHomeownerOccupantRealtor==true):[]
    }
    else{
        notes = notes.length > 0 ? notes.filter( note => {
            if (note.visibilityType === null) {
                return note
            } else if (note.visibilityType === 'Everyone') {
                return note
            } else if (user.roles[0].role.name === 'Property Developer' && (note.visibilityType === 'Property Developer' || note.visibilityType === 'Property Developers')) {
                return note
            } 
            else if (note.visibilityType === user.roles[0].role.name) {
                return note
            } else if (note.visibilityType !== user.roles[0].role.name) {
                if (note.author.id === user.id) {
                    return note
                }
            }
      }) : []
    }
      return notes
};

export const selectMaintenanceGuides = state => searchEntities(state, 'maintenanceguide', ['title', 'body', 'author.firstName', 'author.lastName']);

export const selectDocuments = state => searchEntities(state, 'documents', ['name', 'description', 'type']);

export const selectFaqByIssueType = (state,issueType) => selectFaqs(state).filter( faq => {
    if(typeof(faq.type) === 'object'){
        if(faq.type.includes(issueType))
        {
            return(faq)
        }
        else{return(null)}
    }
    else if(faq.type === issueType){
        return(faq)
    }
})
